<template>
  <div class="pagination">
    <div class="pagination__left">
      <Button icon="icon/arrow-left-full.svg" @click="pageDown"></Button>
      <Button v-for="i in pageCount" :key="`pagination-${i}`" :text="i.toString()" :class="{ active: page === i }"
        @click="page = i"></Button>
      <Button icon="icon/arrow-right-full.svg" @click="pageUp"></Button>
    </div>
    <div class="pagination__right">
      <Button :text="$t(backText)" @click="$emit('back')"></Button>
    </div>
  </div>
</template>

<script>
  import Button from "./Button.vue";

  export default {
    name: "Pagination",
    components: { Button },
    props: {
      pageCount: {
        type: Number,
        default: 1
      },
      backText: {
        type: String,
        default: "back"
      }
    },
    data() {
      return {
        page: 1
      };
    },
    watch: {
      page: function (newPage) {
        this.$emit("page", newPage);
      }
    },
    methods: {
      pageDown() {
        if (this.page > 1) {
          this.page--;
        }
      },
      pageUp() {
        if (this.page < this.pageCount) {
          this.page++;
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
.pagination {
  flex-grow: 1;
  display: flex;
  align-items: center;
}

.button.active {
  background-color: var(--primary-color);
  color: white;
}

.pagination__left {
  flex-grow: 1;
  display: flex;

  .button {
    margin-right: 10px;
  }
}
</style>